import { MediasoupMetricsCollector } from "./MediasoupMetricsCollector";
import { ConsumerStateMetricsCollector } from "./ConsumerStateMetricsCollector";
import { all, flatten } from "ramda";
import { QualityFulfillmentMetricsCollector } from "./QualityFulfillmentMetricsCollector";
export class VideoClientMetricsCollector {
    eventEmitter;
    mediasoup;
    consumerState;
    qualityFulfillment;
    collectors;
    constructor(eventEmitter) {
        this.eventEmitter = eventEmitter;
        this.mediasoup = new MediasoupMetricsCollector(this.eventEmitter);
        this.consumerState = new ConsumerStateMetricsCollector(this.eventEmitter);
        this.qualityFulfillment = new QualityFulfillmentMetricsCollector();
        this.collectors = [this.mediasoup, this.consumerState, this.qualityFulfillment];
    }
    start() {
        this.collectors.forEach((c) => c.start());
    }
    stop() {
        this.collectors.forEach((c) => c.stop());
    }
    resetCollection() {
        this.collectors.forEach((c) => c.resetCollection());
    }
    outputMetrics() {
        const allMetrics = flatten(this.collectors.map((c) => c.outputMetrics()));
        const outputMetric = { name: "video-client", values: {} };
        allMetrics.forEach(({ values }) => {
            outputMetric.values = { ...outputMetric.values, ...values };
        });
        if (all((x) => x === 0)(Object.values(outputMetric.values)))
            return [];
        return [outputMetric];
    }
}
//# sourceMappingURL=VideoClientMetricsCollector.js.map